import { CardsReservationsData } from '@/components/CardsReservations/types';

export interface Checkin {
  checkinDate: string;
  createdAt: string;
  endReservationHour: string;
  firstTime: boolean;
  id: string;
  productId: string;
  startReservationHour: string;
  status: string;
  updatedAt: string;
  userId: string;
}

export interface GetCheckins {
  currentPage: number;
  data: CardsReservationsData[];
  totalPages: number;
  totalResults: number;
}

export interface GetCheckinsProps {
  pageParam: {
    page: number;
    establishmentId: string;
    status?: string[];
    isToday?: boolean;
    startDate?: Date | null | undefined;
    endDate?: Date | null | undefined;
    noLimit?: boolean;
  };
}

export enum CheckinStatus {
  INITIAL = 'INITIAL',
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
  AWAITING_INTEGRATION = 'AWAITING_INTEGRATION',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DONE = 'DONE',
  FAILED_INTEGRATION = 'FAILED_INTEGRATION',
  REFUNDED = 'REFUNDED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}
